import React, {useState} from 'react'
import {SAV_REFERENTIEL_ONGLETS} from '../../../../components/sav/libelles'
import {SavReferentielType} from '../../../../components/sav/Models'
import SavReferentielTab from './SavReferentielTab'
import SavParametresTab from './SavParametresTab'

type Onglet = SavReferentielType | 'parametres'

// Écran 10 : Paramètres › Référentiels SAV
const SavReferentielsPage = () => {
  const [onglet, setOnglet] = useState<Onglet>('sources')
  const courant = SAV_REFERENTIEL_ONGLETS.find((o) => o.type === onglet)

  return (
    <div className='card'>
      <div className='card-header border-0 pt-5'>
        <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
          {[
            ...SAV_REFERENTIEL_ONGLETS.map((o) => ({cle: o.type as Onglet, titre: o.titre})),
            {cle: 'parametres' as Onglet, titre: 'Paramètres'},
          ].map(({cle, titre}) => (
            <li className='nav-item' key={cle}>
              <button
                type='button'
                className={`nav-link btn btn-link text-active-success ${
                  onglet === cle ? 'active' : ''
                }`}
                onClick={() => setOnglet(cle)}
              >
                {titre}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className='card-body'>
        {courant ? (
          <SavReferentielTab
            key={courant.type}
            type={courant.type}
            ajouter={courant.ajouter}
            aide={courant.aide}
          />
        ) : (
          <SavParametresTab />
        )}
      </div>
    </div>
  )
}

export default SavReferentielsPage
